// https://dev.twitch.tv/docs/embed/video-and-clips/#interactive-frames-for-live-streams-and-vods
export default function () {
    const $config = useRuntimeConfig().public;

    const init = async function () {
        return new Promise((resolve) => {
            if (window.Twitch) {
                // console.log('Twitch Player API already exists');
                resolve(true);
            }

            const tag = document.createElement('script');
            tag.src = 'https://player.twitch.tv/js/embed/v1.js';
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            const isLoaded = setInterval(() => {
                if (window.Twitch) {
                    clearInterval(isLoaded);
                    // console.log('Twitch Player API ready');
                    resolve(true);
                }
            }, 100);
        });
    };

    let player = null;

    const attachPlayer = function (channel, id, onPlayerUpdate) {
        if (!window.Twitch) return null;
        if (player) return true;
        const parent = [$config.twitchDomain];
        if ($config.stage === 'dev') parent.push('localhost');
        const options = {
            parent,
            channel: channel,
            width: '100%',
            height: '100%',
            autoplay: true,
            muted: true,
        };
        player = new window.Twitch.Player(id, options);
        player.addEventListener(window.Twitch.Player.CAPTIONS, () => {
            onPlayerUpdate('captions');
        });
        player.addEventListener(window.Twitch.Player.ENDED, () => {
            onPlayerUpdate('ended');
        });
        player.addEventListener(window.Twitch.Player.PAUSE, () => {
            onPlayerUpdate('pause');
        });
        player.addEventListener(window.Twitch.Player.PLAY, () => {
            onPlayerUpdate('play');
        });
        player.addEventListener(window.Twitch.Player.PLAYBACK_BLOCKED, () => {
            onPlayerUpdate('blocked');
        });
        player.addEventListener(window.Twitch.Player.PLAYING, () => {
            onPlayerUpdate('playing');
        });
        player.addEventListener(window.Twitch.Player.OFFLINE, () => {
            onPlayerUpdate('offline');
        });
        player.addEventListener(window.Twitch.Player.ONLINE, () => {
            onPlayerUpdate('online');
        });
        player.addEventListener(window.Twitch.Player.READY, () => {
            onPlayerUpdate('ready');
        });
        player.addEventListener(window.Twitch.Player.SEEK, () => {
            onPlayerUpdate('seek');
        });
        return player;
    };

    return {init, attachPlayer};
}
